import AlsoCategoryPage from 'Components/Also/CategoryPage/CategoryPage'
import AluxoCategoryPage from 'Components/Aluxo/CategoryPage/CategoryPage'
import config from 'Lib/config'

const CategoryPage = config.reseller.also ? AlsoCategoryPage : AluxoCategoryPage

export default CategoryPage
